// extracted by mini-css-extract-plugin
export default {"container":"AdminBooks_container__-nEjT","tab-body":"AdminBooks_tab-body__hvwM5"};